exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 992px) {\n.domain-banner[data-v-f769671a] {\n    background-image: url(\"/img/apiro-claim-banner.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: 265px;\n}\n}\n.animated[data-v-f769671a] {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n@keyframes shake-data-v-f769671a {\nfrom, to {\n    transform: translate3d(0, 0, 0);\n}\n10%, 30%, 50%, 70%, 90% {\n    transform: translate3d(-10px, 0, 0);\n}\n20%, 40%, 60%, 80% {\n    transform: translate3d(10px, 0, 0);\n}\n}\n.shake[data-v-f769671a] {\n  animation-name: shake-data-v-f769671a;\n}", ""]);

// exports
